import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { AddressRepository } from "@entity/data/repositories/address.repository";
import { Address } from "@entity/domain/models/address/address.model";
import { CreateAddress } from "@entity/domain/models/address/create-address.model";
import { inject, injectable } from "inversify";

@injectable()
export class CreateAddressUseCase {
    constructor(
        @inject(AddressRepository)
        private readonly addressRepository: AddressRepository,
    ) {}

    async execute(address: CreateAddress): Promise<Nullable<Address>> {
        const creationResult = await this.addressRepository.create(address);

        if (creationResult.isLeft()) {
            ToastManagerStore.error(creationResult.getLeftOrThrow().message);
        }

        return creationResult.fold(
            () => null,
            (createdAddress) => createdAddress,
        );
    }
}
